module.exports = __webpack_public_path__ + "static/bro4-d8d3ef606160804e7c22847b42841c34.jpg";